import { type StateCreator } from 'zustand';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export type PrivateOfficeState = {
  privateOffice?: boolean;
  agentId?: string;
  promotedBy?: string;
};

type PrivateOfficeActions = {
  setPrivateOffice: (privateOffice?: boolean) => void;
  setAgentId: (agentId?: string) => void;
  setPromotedBy: (promotedBy?: string) => void;
};

export type PrivateOfficeStore = PrivateOfficeState & PrivateOfficeActions;

export const defaultPrivateOfficeState: Readonly<PrivateOfficeState> = {
  privateOffice: false,
  agentId: undefined,
  promotedBy: undefined,
};

export const createPrivateOfficeSlice: StateCreator<SearchStore, MiddlewareType, [], PrivateOfficeStore> = (set) => ({
  ...defaultPrivateOfficeState,
  setAgentId: (agentId?: string) => set({ agentId }, undefined, 'setAgentId'),
  setPromotedBy: (promotedBy?: string) => set({ promotedBy }, undefined, 'setPromotedBy'),
  setPrivateOffice: (privateOffice?: boolean) => set({ privateOffice }, undefined, 'setPrivateOffice'),
});
